import _ from "lodash";
import { getAppConfig } from "config/client.config";
import { licenseMap } from "config/initializers/config.app";

export const FETCH_BLOG = "FETCH_BLOG";
export const FETCH_TEMPLATES = "FETCH_TEMPLATES";
export const INTER_ARTICLE = "INTER_ARTICLE";
export const UPDATE_USER_LICENSE = "UPDATE_USER_LICENSE";

const _fetchBlog = (status, data, err) => {
    return {
        type: FETCH_BLOG,
        data,
        err,
        status,
    };
};

const _fetchTemplates = (status, data, err) => {
    return {
        type: FETCH_TEMPLATES,
        data,
        err,
        status,
    };
};

const _interArticle = (status, data, err) => {
    return {
        type: INTER_ARTICLE,
        data,
        err,
        status,
    };
};
const _updateUserLicense = (status, data, err) => {
    return {
        type: UPDATE_USER_LICENSE,
        data,
        err,
        status,
    };
};

const fetchBlog = () => {
    return (dispatch, getState, Request) => {
        let blogPath = getAppConfig().endpoints.blogPath;
        dispatch(_fetchBlog("fetching", null, null));
        return Request.fetch(blogPath)
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(
                        _fetchBlog("success", { articles: data }, null)
                    );
                });
            })
            .catch((err) => {
                dispatch(_fetchBlog("error", null, err));
                return Promise.reject(err);
            });
    };
};
const fetchTemplates = () => {
    return (dispatch, getState, Request) => {
        let templatesPath = getAppConfig().endpoints.blogTemplatesPath;
        dispatch(_fetchTemplates("fetching", null, null));
        return Request.fetch(templatesPath)
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(
                        _fetchTemplates("success", { articles: data }, null)
                    );
                });
            })
            .catch((err) => {
                dispatch(_fetchTemplates("error", null, err));
                return Promise.reject(err);
            });
    };
};
const fetchLeads = () => {
    return (dispatch, getState, Request) => {
        let leadsPath = getAppConfig().endpoints.leadsPath;
        return Request.fetch(leadsPath)
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
const fetchTags = () => {
    return (dispatch, getState, Request) => {
        let tagsPath = getAppConfig().endpoints.tagsPath;
        return Request.fetch(tagsPath)
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const fetchArticle = (articleId) => {
    return (dispatch, getState, Request) => {
        let getArticlePath = getAppConfig().endpoints.getArticlePath.replace(
            ":id",
            articleId
        );
        return Request.fetch(getArticlePath)
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const fetchArticleAdmin = (articleId) => {
    return (dispatch, getState, Request) => {
        let getArticlePath = getAppConfig()
            .endpoints.getArticlePath.replace(":id", articleId)
            .replace("show", "showAdmin");
        return Request.fetch(getArticlePath)
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const interArticle = (article) => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(_interArticle("success", { article: article }, null))
        );
    };
};

const createArticle = (articleHash) => {
    return (dispatch, getState, Request) => {
        let createArticlePath = getAppConfig().endpoints.createArticlePath;
        return Request.fetch(createArticlePath, {
            method: "POST",
            body: JSON.stringify(articleHash),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                const articles = [...getState().blog.articles, response];
                dispatch(_fetchBlog("success", { articles: articles }, null));
                return response;
            })
            .catch((err) => {
                dispatch(_fetchBlog("error", null, err));
                console.log(err);
            });
    };
};

const updateArticle = (articleId, articleHash) => {
    return (dispatch, getState, Request) => {
        let updateArticlePath =
            getAppConfig().endpoints.updateArticlePath.replace(
                ":id",
                articleId
            );
        return Request.fetch(updateArticlePath, {
            method: "POST",
            body: JSON.stringify(articleHash),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                let articles = _.cloneDeep(getState().blog.articles);
                let thisArticle = _.find(articles, { id: response.id });
                articles.splice(articles.indexOf(thisArticle), 1, response);
                dispatch(_fetchBlog("success", { articles: articles }, null));
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const evalFormula = (formula) => {
    return (dispatch, getState, Request) => {
        let evalFormulaPath = getAppConfig().endpoints.evalFormulaPath;
        return Request.fetch(evalFormulaPath, {
            method: "POST",
            body: JSON.stringify({ formula: formula }),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const createOrder = (plan) => {
    return (dispatch, getState, Request) => {
        let createOrderPath = getAppConfig().endpoints.createOrderPath.replace(
            ":id",
            plan
        );
        return Request.fetch(createOrderPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const createSubscription = (plan) => {
    return (dispatch, getState, Request) => {
        let createSubscriptionPath =
            getAppConfig().endpoints.createSubscriptionPath.replace(
                ":id",
                licenseMap[plan].planId
            );
        return Request.fetch(createSubscriptionPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const verifySubscription = (responseHash) => {
    return (dispatch, getState, Request) => {
        let verifySubscriptionPath =
            getAppConfig().endpoints.verifySubscriptionPath;
        return Request.fetch(verifySubscriptionPath, {
            method: "POST",
            body: JSON.stringify(responseHash),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return dispatch(
                    _updateUserLicense(
                        "success",
                        {
                            license: response.license,
                        },
                        null
                    )
                );
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const verifyOrder = (responseHash) => {
    return (dispatch, getState, Request) => {
        let verifyOrderPath = getAppConfig().endpoints.verifyOrderPath;
        return Request.fetch(verifyOrderPath, {
            method: "POST",
            body: JSON.stringify(responseHash),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return dispatch(
                    _updateUserLicense(
                        "success",
                        {
                            license: response.license,
                        },
                        null
                    )
                );
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const fetchInvoices = (subscriptionId) => {
    return (dispatch, getState, Request) => {
        let getInvoicesPath = getAppConfig().endpoints.getInvoicesPath.replace(
            ":id",
            subscriptionId
        );
        return Request.fetch(getInvoicesPath, {
            method: "GET",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const deleteArticle = (articleId) => {
    return (dispatch, getState, Request) => {
        let deleteArticlePath =
            getAppConfig().endpoints.deleteArticlePath.replace(
                ":id",
                articleId
            );
        return Request.fetch(deleteArticlePath, {
            method: "POST",
        })
            .then((response) => {
                let blogPath = getAppConfig().endpoints.blogPath;
                return Request.fetch(blogPath)
                    .then((response) => {
                        return response.json().then((data) => {
                            return dispatch(
                                _fetchBlog("success", { articles: data }, null)
                            );
                        });
                    })
                    .catch((err) => {
                        dispatch(_fetchBlog("error", null, err));
                        return Promise.reject(err);
                    });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const createTags = (tags) => {
    return (dispatch, getState, Request) => {
        let createTagsPath = getAppConfig().endpoints.createTagsPath;
        return Request.fetch(createTagsPath, {
            method: "POST",
            body: JSON.stringify({ tags: tags }),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const createSCORM = (articleId) => {
    return (dispatch, getState, Request) => {
        let scormifyPath = getAppConfig().endpoints.scormifyPath.replace(
            ":id",
            articleId
        );
        return Request.fetch(scormifyPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const addComment = (articleId, comment) => {
    return (dispatch, getState, Request) => {
        let createArticleCommentPath =
            getAppConfig().endpoints.createArticleCommentPath.replace(
                ":id",
                articleId
            );
        return Request.fetch(createArticleCommentPath, {
            method: "POST",
            body: JSON.stringify({ comment: comment }),
        })
            .then((response) => {
                return response.json().then((data) => {
                    let blogPath = getAppConfig().endpoints.blogPath;
                    return Request.fetch(blogPath)
                        .then((response) => {
                            return response.json().then((data) => {
                                return dispatch(
                                    _fetchBlog(
                                        "success",
                                        { articles: data },
                                        null
                                    )
                                );
                            });
                        })
                        .catch((err) => {
                            dispatch(_fetchBlog("error", null, err));
                            return Promise.reject(err);
                        });
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const deleteComment = (articleId, commentId) => {
    return (dispatch, getState, Request) => {
        let deleteArticleCommentPath = getAppConfig()
            .endpoints.deleteArticleCommentPath.replace(":id", articleId)
            .replace(":comment_id", commentId);
        return Request.fetch(deleteArticleCommentPath, {
            method: "POST",
        })
            .then((response) => {
                return response.json().then((data) => {
                    let blogPath = getAppConfig().endpoints.blogPath;
                    return Request.fetch(blogPath)
                        .then((response) => {
                            return response.json().then((data) => {
                                return dispatch(
                                    _fetchBlog(
                                        "success",
                                        { articles: data },
                                        null
                                    )
                                );
                            });
                        })
                        .catch((err) => {
                            dispatch(_fetchBlog("error", null, err));
                            return Promise.reject(err);
                        });
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
const fetchArticleLeaderboard = (identifier) => {
    return (dispatch, getState, Request) => {
        return Request.fetch("/api/v2/analytics/gamifix_leaderboard", {
            method: "POST",
            body: JSON.stringify({
                team: "Company",
                season: "Forever",
                currency: `${identifier} Points`,
            }),
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
class BlogAction {
    static fetchBlog = fetchBlog;
    static fetchTemplates = fetchTemplates;
    static fetchLeads = fetchLeads;
    static fetchTags = fetchTags;
    static fetchArticle = fetchArticle;
    static fetchArticleAdmin = fetchArticleAdmin;
    static createArticle = createArticle;
    static interArticle = interArticle;
    static createTags = createTags;
    static updateArticle = updateArticle;
    static addComment = addComment;
    static deleteComment = deleteComment;
    static deleteArticle = deleteArticle;
    static evalFormula = evalFormula;
    static createSubscription = createSubscription;
    static createOrder = createOrder;
    static verifySubscription = verifySubscription;
    static verifyOrder = verifyOrder;
    static fetchInvoices = fetchInvoices;
    static createSCORM = createSCORM;
    static fetchArticleLeaderboard = fetchArticleLeaderboard;
}

export default BlogAction;
